// Imports for external libraries go here.
import React, { FC } from 'react';
import { InfoWindow } from '@react-google-maps/api';

import { MapInfoWindowProps } from './MapInfoWindow.types';
import { StyledMapInfoWindow } from './MapInfoWindow.styles';

// Use named rather than default exports.
export const MapInfoWindow: FC<MapInfoWindowProps> = ({ ...props }) => {
  return (
    <StyledMapInfoWindow data-component-name="a-ui-library-MapInfoWindow" data-testid="ui-library-MapInfoWindow">
      <InfoWindow {...props}>{props.children}</InfoWindow>
    </StyledMapInfoWindow>
  );
};
